module.exports = __webpack_public_path__ + "img/tmx_logo_slide_re.0b92dd5c.jpg";